"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
const categories = [{
  title: "Residential Junk",
  description: "Full-service removal for homes, apartments, and estates across Ottawa."
}, {
  title: "Commercial Services",
  description: "Professional debris and office furniture removal for local businesses."
}, {
  title: "Appliance Disposal",
  description: "Eco-friendly recycling and disposal of old fridges, washers, and more."
}, {
  title: "Furniture Removal",
  description: "Quick pickup of couches, mattresses, and heavy household items."
}];
export default function BlogCategories() {
  return <section id="blog-categories" className="pt-[128px] pb-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="mb-12 max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-bold font-serif mb-4 text-foreground">
            Browse by Category
          </h2>
          <p className="text-muted-foreground text-lg">
            Select a category to find specialized advice and updates on our local Ottawa removal services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category, i) => {
          const cardStyles = ["bg-primary text-primary-foreground border-primary", "bg-secondary text-secondary-foreground border-secondary", "bg-card text-card-foreground border-border", "bg-card text-card-foreground border-border"];
          const buttonVariants = ["outline", "default", "secondary", "outline"] as const;
          return <div key={category.title} data-index={i} className={`group relative p-8 rounded-lg border transition-all duration-300 hover:shadow-xl hover:-translate-y-1 flex flex-col justify-between min-h-[240px] ${cardStyles[i]}`}>
                <div>
                  <h3 className="text-xl font-bold font-serif mb-3">
                    {category.title}
                  </h3>
                  <p className={`text-sm leading-relaxed mb-6 ${i === 0 ? "text-primary-foreground/80" : i === 1 ? "text-secondary-foreground/80" : "text-muted-foreground"}`}>
                    {category.description}
                  </p>
                </div>
                
                <Link to="/BlogPage" className="mt-auto">
                  <Button variant={i === 1 ? "default" : "outline"} className={`w-full justify-between rounded-lg font-mono text-xs uppercase tracking-wider ${i === 0 ? "border-primary-foreground/20 hover:bg-primary-foreground hover:text-primary" : i === 1 ? "bg-foreground text-background hover:bg-foreground/90 border-none" : ""}`}>
                    View Posts
                    <ArrowRight className="size-4" />
                  </Button>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}